import * as Yup from "yup";

import {
  AkaStudentProductIntroFormValues,
  CountryCode,
} from "./akaStudentProductIntroInterfaces";

import { TextManager } from "Components/TextContext";
import { Country } from "Store/texts/interfaces";
import { isCountryNotAllowed } from "./akaStudentProductIntroUtils";

export const validationSchema = (
  countries: Country[],
  countriesNotAllowed: string[],
): Yup.ObjectSchema<AkaStudentProductIntroFormValues> => {
  const { getText } = TextManager;
  return Yup.object()
    .defined()
    .shape({
      country: Yup.string()
        .required(getText("akastudentform.validation.country_required"))
        .test(
          "if country is a valid country",
          getText("akastudentform.validation.country_invalid"),
          (value) => isValidCountry(countries, value ?? ""),
        )
        .test(
          "Country not allowed",
          getText("akastudentform.validation.country_not_allowed"),
          (value) => {
            return value
              ? !isCountryNotAllowed(value, countriesNotAllowed)
              : true;
          },
        ),
      region: Yup.mixed<CountryCode>().required(),
    });
};

const isValidCountry = (countries: Country[], country: string): boolean =>
  countries.some(
    (instance) =>
      instance.name.toLocaleLowerCase() === country.toLocaleLowerCase(),
  );
